import React from 'react';
import styles from './FloFilterCheckbox.module.css';
import { FloCheckbox, FloComponentProps, FloFilterGroup } from 'components';

interface FloFilterCheckboxProps extends FloComponentProps {
  groupLabel: string;
  onChange: () => void;
  checked: boolean,
}

export const FloFilterCheckbox: React.FC<FloFilterCheckboxProps> = React.memo(({
  groupLabel,
  onChange,
  checked,
}) => {

  return (
    <FloFilterGroup label={groupLabel} >
      <div className={styles.wrapper}>
        <FloCheckbox onChange={onChange} noMargin checked={checked} />
      </div>
    </FloFilterGroup>
  );
});

export const FloAlertFilterCheckbox: React.FC<FloFilterCheckboxProps> = React.memo(({
  groupLabel,
  onChange,
  checked,
}) => {

  return (
    <FloFilterGroup label={groupLabel} >
      <div className={styles.alertWrapper}>
        <FloCheckbox onChange={onChange} noMargin checked={checked} />
      </div>
    </FloFilterGroup>
  );
});